module.exports = __webpack_public_path__ + "static/img/pickPeople.bcaffba.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icon/firstToolList/pickPeople.png
// module id = +u+A
// module chunks = 1